import { getShortAgents } from '../../../api';

export const getShortAgentsMap = async () => {
  const data = await getShortAgents();
  return (
    data?.reduce<Record<string, string>>((acc, curr) => {
      if (curr.id) {
        acc[curr.id] = curr.title ?? '';
      }
      return acc;
    }, {}) ?? {}
  );
};
